module.exports = __webpack_public_path__ + "img/pen-icon.2a27e5bc.svg";